import React from 'react';


import component, {classnames} from './component';


export const TableListRow = component('TableListRow', ({children, height, bordered, grayedOut}) => {

  return (
    <div className={classnames('TableListRow', {
        'TableListRow--Bordered': bordered,
        'TableListRow--GrayedOut': grayedOut
        })} style={{height}}>
      {children}
    </div>
  )

});

export const TableListCell = component('TableListCell', ({type, centered, children,
  width, header, bgSrc, button, stubBg}) => {

  const cls = classnames('TableListCell', {
    [`TableListCell-${type}`]: true,
    'TableListCell--Centered': centered
  });

  const st = {};
  if (width) {
    st.width = width;
  }
  if (bgSrc) {
    st.backgroundImage = `url(${bgSrc}?crop=1&w=${width}&h=${width}})`;
  } else if (stubBg) {
    st.backgroundImage = `url(${require('../img/teamEmptyAvatarSquare.png')})`;
  }

  return (
    <div className={cls} style={st}>
      <div className='TableListCell-Content'>
        <div className={`TableListCell-${type}Header`}>{header}</div>
        <div className={`TableListCell-${type}Content`}>
          {!button ? children :
            <div className='TableListCell-ButtonContainer'>
              <div>{children}</div>
              <div className='TableListCell-Button'>{button}</div>
            </div>
          }
        </div>
      </div>
    </div>
  )

});





// WEBPACK FOOTER //
// ./src/components/TableList.js